<template>

<app-content-box title="Looking for Players Now" :not-padded="true" icon="looking" :loading="is.loading" :is-empty="!looking.length" empty-message="No one currently looking.">

	<div class="looking-item" v-tooltip="(item.event) ? 'Click to view event page' : false" :class="{'can-click': item.event}" v-for="item in looking" :key="item.id" v-on:click="onClick(item)">
        <div class="looking-item-text">{{ item.name }}</div>
        <div class="looking-item-location">{{ item.location }}</div>
        <div class="looking-item-date">{{ item.date | fromNow }}</div>
    </div>

</app-content-box>

</template>

<script>

export default {

    data: function() {
    
        return {
            is: {
                loading: true,
                initial: true
            },
            looking: []
        }

    },

    created: function() {

		this.$live.$on('convention/looking', this.onActivity.bind(this))

		this.load()

	},

	beforeDestroy: function() {

		this.$live.$off('convention/looking', this.onActivity.bind(this))

	},

	methods: {

        onClick: function(item) {

            if(!item.event) return false
        
            this.$router.push({
                name: 'Convention.Schedule.Event',
                params: {
                    id: item.event
                }
            })

        },

		load: function() {

			this.is.loading = true

			this.$api.get('convention/looking', {
                perpage: 25
            }).then(function(response) {

				this.looking = response.collection
				this.is.loading = false
				this.is.initial = false

			}.bind(this))

		},

		onActivity: function() {

			this.load()

		}

	}

}

</script>

<style scoped>

.looking-item {
    padding: 10px;
    border-bottom: 1px solid #eee;
    padding-right: 150px;
}

.looking-item.can-click {
    cursor: pointer;
}

.looking-item-text {
    font-size: 24px;
    font-weight: 500;
}

.looking-item-location {
    font-size: 14px;
    font-weight: 400;
    margin-top: 2px;
    color: #687589;
}

.looking-item-date {
    font-size: 16px;
    color: #687589;
    font-weight: 700;
    color: #4082d3;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
}

</style>